'use stict';

/**
 * Smoothly scrolls to an element, considering header height and an offset.
 * @param {HTMLElement} element - The DOM element to scroll to.
 */
export function scrollToElement(element) {
    const headerOffset = document.querySelector('.js-page-header').offsetHeight + 32;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}

/**
 * Sets classes on an element based on its scroll position.
 * @param {HTMLElement} el - The scrollable DOM element.
 */
export function setScrollClasses(el) {
    const isScrollable = el.scrollHeight > el.clientHeight;

    if (!isScrollable) {
        el.classList.remove('is-bottom-overflowing', 'is-top-overflowing');
        return;
    }

    const isScrolledToBottom = el.scrollHeight <= el.clientHeight + el.scrollTop + 1;
    const isScrolledToTop = el.scrollTop === 0;

    el.classList.toggle('is-bottom-overflowing', !isScrolledToBottom);
    el.classList.toggle('is-top-overflowing', !isScrolledToTop);
}
